import { render } from "./CurrentSubscriptionReturnRedirect.vue.js?vue&type=template&id=1dd22cc1!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CurrentSubscriptionReturnRedirect.vue?vue&type=template&id=1dd22cc1"
import script from "./CurrentSubscriptionReturnRedirect.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CurrentSubscriptionReturnRedirect.vue?vue&type=script&lang=js"
export * from "./CurrentSubscriptionReturnRedirect.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CurrentSubscriptionReturnRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/current-subscription/CurrentSubscriptionReturnRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dd22cc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dd22cc1', __exports__)) {
    api.reload('1dd22cc1', __exports__)
  }
  
  module.hot.accept("./CurrentSubscriptionReturnRedirect.vue.js?vue&type=template&id=1dd22cc1!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CurrentSubscriptionReturnRedirect.vue?vue&type=template&id=1dd22cc1", () => {
    api.rerender('1dd22cc1', render)
  })

}


export default __exports__